import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import ButtonLoading from "../Button/ButtonLoading";
import { useSnackbar } from "notistack";

import ApiClient from "../../services/ApiClient";
import { useCurrentUser } from "../../provider/CurrentUserProvider";

export default function ChangePassword() {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const currentUser = useCurrentUser();

  const handleNewPassword = () => {
    setIsLoading(true);

    ApiClient.post("reset_user_password", { body: JSON.stringify({ email: currentUser.email }) })
      .then(() => {
        enqueueSnackbar("Wir haben Ihnen eine E-Mail zum Ändern Ihres Passworts geschickt.", {
          variant: "custom",
          isNonInteractive: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center"
      }}>
      <Typography>
        <strong>Sie möchten Ihr Passwort ändern?</strong>
      </Typography>
      <Typography>Fordern Sie hier ganz einfach eine E-Mail an, um ein neues Passwort zu wählen.</Typography>
      <ButtonLoading onClick={handleNewPassword} isLoading={isLoading} variant={"contained"} sx={{ width: "200px" }}>
        E-Mail anfordern
      </ButtonLoading>
    </Stack>
  );
}
